import Column from 'antd/lib/table/Column';
import MinusSvgComponent from 'assets/svg/Minus';
import CalenderEventItem from 'components/molecules/CalenderEventItem';
import Legend from 'components/molecules/Legend';
import { colorConstants } from 'config/colorConstants';
import tw from 'twin.macro';
import { renderTitle } from './getSalesAttributionColumns';
import { calculateFontSize, fetchCurrency, formatNumWithKMBAlt } from './helperMethods';
import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import { tileDataProp } from 'components/atoms/TileButton';
import { calenderMinRowHeight } from 'components/template/BumpReport/MainSection';
import { Popover, Tooltip } from 'antd';

type legendProps = dataItem[];

const firstColumnWidth = calculateFontSize(window.innerWidth, 160);

type dataItem = {
    label: string;
    color: string;
};
//promo calendar columns
export const getBumpReportColumns = (
    data: any,
    legendData: legendProps,
    toggleCalender: Function,
    colWidth: number,
    config: any,
    volTile: any,
    isMedia: boolean = false,
    selectedBumpReportTile1Data: any,
) => {
    const { bumpReport } = config;
    const item = data ? data[1] : null;
    const currency = volTile?.key === 'val' ? fetchCurrency(config) : '';
    const result: any[] = [];
    const keyItems = data?.length > 0 ? Object.keys(item).slice(4) : []; //removing first item promo calendar
    const weekBorderStyle: any = {
        position: 'absolute',
        top: 0,
        bottom: 0,
        borderRight: `1px dashed ${colorConstants.borderGreyAlt}`,
    };
    if (keyItems && keyItems.length > 0) {
        //   1st column

        result.push({
            title: renderTitle(
                `${isMedia ? 'Media' : 'Promo'} Calendar`,
                undefined,
                undefined,
                'text-purpleFont !font-bold',
                graphXAxisLabelFontSize,
            ),
            dataIndex: 'ppg',
            key: 'key',
            fixed: 'left',
            align: 'center',
            // width: Math.max(colWidth, 140),
            width: firstColumnWidth,
            onCell: (record: any, rowIndex: any) => ({
                style: {
                    fontWeight: 500,
                    color: colorConstants.fontGrey,
                    paddingInline: 10,
                    paddingBlock: rowIndex === 0 ? 2 : 2,
                    background: 'white',
                    position: 'relative',
                    zIndex: 4,
                    borderRight: `1px solid ${colorConstants.borderGrey}`,
                    height: rowIndex === 0 ? 'auto' : calenderMinRowHeight,
                },
            }),
            render: (colVal: any, rowVal: any) => {
                const { dim2FormattedName, dim2AttributeNames } = rowVal;
                if (colVal) {
                    return (
                        <>
                            <div className="font-xs">
                                {colVal}{' '}
                                {dim2FormattedName ? (
                                    <Tooltip
                                        overlayInnerStyle={{
                                            fontSize: graphXAxisLabelFontSize,
                                            fontWeight: 500,
                                        }}
                                        title={dim2AttributeNames}
                                        placement="top"
                                        trigger={'hover'}
                                    >
                                        {dim2FormattedName}
                                    </Tooltip>
                                ) : null}
                            </div>
                        </>
                    );
                }
            },
        });
        //2nd to n-1 columns
        const dateColumns =
            (keyItems &&
                keyItems.length > 0 &&
                keyItems.map((item, index) => {
                    return {
                        title: renderTitle(
                            item,
                            undefined,
                            undefined,
                            'text-purpleFont !font-bold !justify-start !pl-0',
                            graphXAxisLabelFontSize,
                        ),
                        dataIndex: item,
                        key: item,
                        align: 'left',
                        width: colWidth,
                        // colSpan: rowIndex === 0 ? (index === 0 ? keyItems.length + 1 : 0) : 1,
                        onCell: (record: any, rowIndex: any) => ({
                            style: {
                                paddingInline: 0,
                                paddingBlock: rowIndex === 0 ? 0 : 2,
                                verticalAlign: 'top',
                                borderRight: `1px solid ${colorConstants.borderGrey}`,
                            },
                            colSpan: rowIndex === 0 ? (index === 0 ? keyItems.length : 0) : 1,
                            rowSpan: 1,
                        }),
                        render: (colVal: any, rowVal: any, rowIndex: number) => {
                            return (
                                <>
                                    <div className="relative">
                                        {rowIndex === 0 ? (
                                            <div className="h-[50px]">
                                                {/* <Legend style={{ marginBlock: 5 }} data={legendData} /> */}
                                            </div>
                                        ) : (
                                            colVal?.length > 0 &&
                                            colVal.map((val: any, index: number) => {
                                                const style = val.style || {};
                                                return (
                                                    <CalenderEventItem
                                                        item={val}
                                                        pre={currency}
                                                        style={style}
                                                        overlayKeyMapping={
                                                            bumpReport?.overlayKeys?.[selectedBumpReportTile1Data?.key]
                                                        }
                                                    />
                                                );
                                            })
                                        )}
                                    </div>
                                    {rowIndex !== 0 && (
                                        <div>
                                            <div style={{ ...weekBorderStyle, width: (colWidth / 4) * 1 }}> </div>
                                            <div style={{ ...weekBorderStyle, width: (colWidth / 4) * 2 }}> </div>
                                            <div style={{ ...weekBorderStyle, width: (colWidth / 4) * 3 }}> </div>
                                        </div>
                                    )}
                                </>
                            );
                        },
                    };
                })) ||
            [];
        result.push(...dateColumns);
        // last Column
        result.push({
            title: (
                <div className="flex justify-end mr-4 ">
                    <span onClick={() => toggleCalender()} className="p-1 cursor-pointer">
                        <MinusSvgComponent />
                    </span>
                </div>
            ),
            dataIndex: 'collapse',
            key: 'collapse',
            align: 'center',
            width: '90px',
            onCell: (record: any, rowIndex: any) => ({
                style: {
                    padding: 0,
                    background: 'white',
                },
            }),
        });
    }

    return result;
};

//bump comparison columns
export const getComparisonColumns = (
    data: any,
    volTile: tileDataProp,
    decimalForNonPercentage: number,
    decimalForPercentage: number,
) => {
    const item = data[0];
    const keyItems = data?.length > 0 ? Object.keys(item) : [];
    const dateColumns = keyItems.map((item, index) => {
        return {
            title: renderTitle(
                index === 0 ? 'KPIs' : item,
                index == 0 ? null : 'center',
                undefined,
                'text-purpleFont !font-bold',
                graphXAxisLabelFontSize,
            ),
            dataIndex: item,
            key: item,
            fixed: index === 0 ? 'left' : null,
            align: index === 0 ? 'left' : 'center',
            width: '100px',
            onCell: (record: any, rowIndex: any) => ({
                style: {
                    borderRight: index == 0 ? `1px solid ${colorConstants.borderGrey}` : '',
                },
            }),
            render: (colVal: any, rowVal: any, rowIndex: number) => {
                return (
                    <div className="relative font-xs">
                        {Array.isArray(colVal) //only show dollar when tile is value
                            ? volTile?.key === 'vol'
                                ? formatNumWithKMBAlt(colVal[1], decimalForNonPercentage, decimalForNonPercentage)
                                : colVal[0] +
                                  formatNumWithKMBAlt(
                                      colVal[1],
                                      colVal[2] !== '%' ? decimalForNonPercentage : decimalForPercentage,
                                      colVal[2] !== '%' ? decimalForNonPercentage : undefined,
                                  ) +
                                  colVal[2]
                            : colVal}
                    </div>
                );
            },
        };
    });
    return dateColumns;
};
